export const PRICE_TYPES = Object.freeze({
  adult: "adult",
  child: "child",
  senior: "senior",
});
